import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './BoxShadow.scss';

const BoxShadow = (props) => {
  const { children, className } = props;
  const dist = props.dist || 'subtle';
  const classes = cn(['box_shadow', `bs--dist_${dist}`, className]);

  return <div className={classes}>{children}</div>;
};

BoxShadow.propTypes = {
  dist: PropTypes.oneOf(['flush', 'subtle', 'low', 'med', 'high']),
};

export default BoxShadow;
